export default (namespace) => ({
  [`${namespace}.firstTitle`]: 'Primero, ¿cuándo quieres estar protegido?',
  [`${namespace}.secondTitle`]: 'Y ahora, elige tus coberturas',
});
